// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Stock Summary Styles */
.stocksummary-container {
  max-width: 1400px;

  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header */

.stocksummary-header {
  position: relative;
  /* background: var(--land-gradient-purple); */
  background: linear-gradient(135deg, #111c30c2 100%, #cadcfc 50%);
  color: white;
  padding: 1rem 1rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-radius: 0 0 0rem 0rem;
  box-shadow: var(--land-shadow-lg);
}

.stocksummary-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.stocksummary-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: landFloat 6s ease-in-out infinite;
}

.stocksummary-shape-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.stocksummary-shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.stocksummary-shape-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.stocksummary-shape-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes landFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.stocksummary-header-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.stocksummary-title {
  /* font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem; */
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.stocksummary-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 300;
}

/* Tabs */
.stocksummary-tabs {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 30px;
  background: white;
  padding: 6px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
}

.stocksummary-tab {
  flex: 1 1;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.stocksummary-tab:hover {
  background-color: #475569;
  color: #f0f0f0;
  /* color: #475569; */
}

.stocksummary-tab-active {
  /* background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #111c30c2;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Loading */
.stocksummary-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.stocksummary-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: stocksummary-spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes stocksummary-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Section */
.stocksummary-section {
  /* background: white; */
  border-radius: 12px;
  padding: 25px;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}

/* Top Controls */
.stocksummary-top-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  gap: 15px;
  flex-wrap: wrap;
}

.stocksummary-search-wrapper,
.stocksummary-select-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 400px;
}

.stocksummary-search,
.stocksummary-select {
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  transition: all 0.3s ease;
  outline: none;
}

.stocksummary-search:focus,
.stocksummary-select:focus {
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.stocksummary-clear-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s ease;
}

.stocksummary-clear-btn:hover {
  color: #ef4444;
}

.stocksummary-print-btn,
.stocksummary-add-btn {
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.stocksummary-print-btn {
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #475569;
  color: white;
  /* box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); */
}

.stocksummary-print-btn:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4); */
}

.stocksummary-add-btn {
  /* background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #475569;
  color: white;
  /* box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3); */
  margin-right: 10px;
}

.stocksummary-add-btn:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4); */
}

/* Site Title */
.stocksummary-site-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 15px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 8px;
  border-left: 4px solid #3b82f6;
}

/* Table */
.stocksummary-table-container {
  overflow-x: auto;
  border-radius: 12px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  border: 1px solid #e2e8f0;
  /* max-width: fit-content; */
}

.stocksummary-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  min-width: 800px;
}

.stocksummary-th {
  /* background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); */
  color: #374151;
  background: #f3f4f6;
  font-size: 13px;
  font-weight: 700;
  padding: 16px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stocksummary-tr {
  transition: all 0.2s ease;
}

.stocksummary-tr:hover {
  background-color: #f8fafc;
}

/* .stocksummary-tr:nth-child(even) {
  background-color: #fafbfc;
} */

.stocksummary-td {
  padding: 16px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
}

.stocksummary-material-name {
  font-weight: 600;
  color: #1e293b;
}

/* Quantity Badges */
.stocksummary-quantity-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 0.5rem;
  font-size: 12px;
  font-weight: 700;
  background: #e2e8f0;
  color: #374151;
  min-width: 40px;
  text-align: center;
}

@keyframes stocksummary-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Site Distribution */
.stocksummary-site-distribution {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  vertical-align: middle;
}

.stocksummary-site-item {
  display: flex;
  /* justify-content: space-between; */
  /* justify-content: end; */
  align-items: center;
  /* padding: 8px 12px; */
  /* background: #f8fafc; */
  border-radius: 6px;
  /* border: 1px solid #e2e8f0; */
}

.stocksummary-site-name {
  font-weight: 600;
  font-size: 12px;
  color: #374151;
}

.stocksummary-site-quantity {
  font-weight: 700;
  color: #3b82f6;
  background: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
}

/* Form Overlay */
.stocksummary-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.stocksummary-form {
  background: white;
  border-radius: 12px;
  padding: 30px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.stocksummary-form-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 25px 0;
  text-align: center;
}

.stocksummary-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.stocksummary-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stocksummary-form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.stocksummary-form-input,
.stocksummary-form-select {
  padding: 12px 16px;
  font-size: 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  transition: all 0.3s ease;
  outline: none;
}

.stocksummary-form-input:focus,
.stocksummary-form-select:focus {
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.stocksummary-form-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.stocksummary-submit-btn,
.stocksummary-cancel-btn {
  padding: 12px 30px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.stocksummary-submit-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.stocksummary-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.stocksummary-cancel-btn {
  background: #f1f5f9;
  color: #64748b;
  border: 2px solid #e2e8f0;
}

.stocksummary-cancel-btn:hover {
  background: #e2e8f0;
  color: #475569;
}

/* Empty State */
.stocksummary-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}

.stocksummary-no-data {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .stocksummary-container {
    /* padding: 15px; */
  }

  .stocksummary-section {
    padding: 20px;
  }
}

@media (max-width: 768px) {
  /* .stocksummary-title {
    font-size: 2rem;
  } */

  .stocksummary-tabs {
    flex-direction: column;
    gap: 8px;
  }

  .stocksummary-tab {
    width: 100%;
  }

  .stocksummary-top-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .stocksummary-search-wrapper,
  .stocksummary-select-wrapper {
    max-width: none;
  }

  .stocksummary-form-grid {
    grid-template-columns: 1fr;
  }

  .stocksummary-form-buttons {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .stocksummary-container {
    padding: 10px;
  }

  .stocksummary-section {
    padding: 15px;
  }

  .stocksummary-th,
  .stocksummary-td {
    padding: 12px 8px;
    font-size: 12px;
  }

  /* .stocksummary-site-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  } */
}

/* Print Styles */
@media print {
  .stocksummary-container {
    background: white;
    box-shadow: none;
  }

  .stocksummary-top-controls,
  .stocksummary-tabs,
  .stocksummary-print-btn,
  .stocksummary-add-btn {
    display: none;
  }

  .stocksummary-table-container {
    box-shadow: none;
    border: 1px solid #000;
  }

  .stocksummary-th {
    background: #f0f0f0 !important;
    color: #000 !important;
  }
}

/* **** */

/* stocksummary.css */

/* Base styles */
.stocksummary-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
  box-sizing: border-box;
}

.stocksummary-popup {
  /* background-color: #ffffff; */
  border-radius: 8px;
  padding: 2rem;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow-y: auto;
  /* max-height: 90vh; */
}
.Used_button {
  padding: 10px 20px;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
}

.stocksummary-form {
  display: flex;
  flex-direction: column;
  /* gap: 1.5rem; */
}

/* .stocksummary-title {
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  text-align: center;
  color: #333;
} */

.stocksummary-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.stocksummary-label {
  font-size: 1rem;
  font-weight: 600;
  color: #555;
}

.stocksummary-input,
.stocksummary-select,
.stocksummary-textarea {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.stocksummary-input:focus,
.stocksummary-select:focus,
.stocksummary-textarea:focus {
  border-color: #007bff;
  outline: none;
}

.stocksummary-textarea {
  resize: vertical;
  min-height: 100px;
}

.stocksummary-submit-btn {
  background-color: #007bff;
  color: #ffffff;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.stocksummary-submit-btn:hover {
  background-color: #0056b3;
}

.stocksummary-close-btn {
  position: absolute;
  top: 2rem;
  right: 3rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ff0000;
  transition: color 0.3s ease;
}

.stocksummary-close-btn:hover {
  color: #333;
}

/* Responsive styles */
@media (max-width: 768px) {
  .stocksummary-popup {
    padding: 1.5rem;
    max-width: 90%;
  }

  .stocksummary-title {
    font-size: 1.25rem;
  }

  .stocksummary-label {
    font-size: 0.9rem;
  }

  .stocksummary-input,
  .stocksummary-select,
  .stocksummary-textarea {
    font-size: 0.9rem;
    padding: 0.6rem;
  }

  .stocksummary-submit-btn {
    font-size: 0.9rem;
    padding: 0.6rem;
  }

  .stocksummary-close-btn {
    font-size: 1.25rem;
    top: 0.75rem;
    right: 0.75rem;
  }
}

@media (max-width: 480px) {
  .stocksummary-overlay {
    padding: 0.5rem;
  }

  .stocksummary-popup {
    padding: 1rem;
    max-height: 95vh;
  }

  .stocksummary-form {
    gap: 1rem;
  }

  .stocksummary-field {
    gap: 0.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/StockSummary.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;;EAEjB;cACY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,gEAAgE;EAChE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;0BAEwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mEAAmE;EACnE,mEAAmE;EACnE,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,mEAAmE;EACnE,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;;KAIG;AACL;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;AACF;;AAEA,SAAS;;AAET,qBAAqB;;AAErB,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Stock Summary Styles */\n.stocksummary-container {\n  max-width: 1400px;\n\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header */\n\n.stocksummary-header {\n  position: relative;\n  /* background: var(--land-gradient-purple); */\n  background: linear-gradient(135deg, #111c30c2 100%, #cadcfc 50%);\n  color: white;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  border-radius: 0 0 0rem 0rem;\n  box-shadow: var(--land-shadow-lg);\n}\n\n.stocksummary-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.stocksummary-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: landFloat 6s ease-in-out infinite;\n}\n\n.stocksummary-shape-1 {\n  width: 100px;\n  height: 100px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.stocksummary-shape-2 {\n  width: 150px;\n  height: 150px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.stocksummary-shape-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.stocksummary-shape-4 {\n  width: 120px;\n  height: 120px;\n  top: 10%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n@keyframes landFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n}\n\n.stocksummary-header-content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.stocksummary-title {\n  /* font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem; */\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.stocksummary-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n/* Tabs */\n.stocksummary-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-bottom: 30px;\n  background: white;\n  padding: 6px;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 30px;\n}\n\n.stocksummary-tab {\n  flex: 1;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.stocksummary-tab:hover {\n  background-color: #475569;\n  color: #f0f0f0;\n  /* color: #475569; */\n}\n\n.stocksummary-tab-active {\n  /* background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #111c30c2;\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Loading */\n.stocksummary-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.stocksummary-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: stocksummary-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes stocksummary-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Section */\n.stocksummary-section {\n  /* background: white; */\n  border-radius: 12px;\n  padding: 25px;\n  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */\n}\n\n/* Top Controls */\n.stocksummary-top-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.stocksummary-search-wrapper,\n.stocksummary-select-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 400px;\n}\n\n.stocksummary-search,\n.stocksummary-select {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.stocksummary-search:focus,\n.stocksummary-select:focus {\n  border-color: #3b82f6;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.stocksummary-clear-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.2s ease;\n}\n\n.stocksummary-clear-btn:hover {\n  color: #ef4444;\n}\n\n.stocksummary-print-btn,\n.stocksummary-add-btn {\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.stocksummary-print-btn {\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #475569;\n  color: white;\n  /* box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); */\n}\n\n.stocksummary-print-btn:hover {\n  transform: translateY(-2px);\n  /* box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4); */\n}\n\n.stocksummary-add-btn {\n  /* background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #475569;\n  color: white;\n  /* box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3); */\n  margin-right: 10px;\n}\n\n.stocksummary-add-btn:hover {\n  transform: translateY(-2px);\n  /* box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4); */\n}\n\n/* Site Title */\n.stocksummary-site-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 15px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  border-radius: 8px;\n  border-left: 4px solid #3b82f6;\n}\n\n/* Table */\n.stocksummary-table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */\n  border: 1px solid #e2e8f0;\n  /* max-width: fit-content; */\n}\n\n.stocksummary-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  min-width: 800px;\n}\n\n.stocksummary-th {\n  /* background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); */\n  color: #374151;\n  background: #f3f4f6;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 16px;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stocksummary-tr {\n  transition: all 0.2s ease;\n}\n\n.stocksummary-tr:hover {\n  background-color: #f8fafc;\n}\n\n/* .stocksummary-tr:nth-child(even) {\n  background-color: #fafbfc;\n} */\n\n.stocksummary-td {\n  padding: 16px;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n}\n\n.stocksummary-material-name {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Quantity Badges */\n.stocksummary-quantity-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 0.5rem;\n  font-size: 12px;\n  font-weight: 700;\n  background: #e2e8f0;\n  color: #374151;\n  min-width: 40px;\n  text-align: center;\n}\n\n@keyframes stocksummary-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Site Distribution */\n.stocksummary-site-distribution {\n  display: flex;\n  flex-direction: column;\n  /* gap: 8px; */\n  vertical-align: middle;\n}\n\n.stocksummary-site-item {\n  display: flex;\n  /* justify-content: space-between; */\n  /* justify-content: end; */\n  align-items: center;\n  /* padding: 8px 12px; */\n  /* background: #f8fafc; */\n  border-radius: 6px;\n  /* border: 1px solid #e2e8f0; */\n}\n\n.stocksummary-site-name {\n  font-weight: 600;\n  font-size: 12px;\n  color: #374151;\n}\n\n.stocksummary-site-quantity {\n  font-weight: 700;\n  color: #3b82f6;\n  background: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n}\n\n/* Form Overlay */\n.stocksummary-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.stocksummary-form {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.stocksummary-form-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 25px 0;\n  text-align: center;\n}\n\n.stocksummary-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.stocksummary-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stocksummary-form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.stocksummary-form-input,\n.stocksummary-form-select {\n  padding: 12px 16px;\n  font-size: 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.stocksummary-form-input:focus,\n.stocksummary-form-select:focus {\n  border-color: #3b82f6;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.stocksummary-form-buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.stocksummary-submit-btn,\n.stocksummary-cancel-btn {\n  padding: 12px 30px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.stocksummary-submit-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.stocksummary-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.stocksummary-cancel-btn {\n  background: #f1f5f9;\n  color: #64748b;\n  border: 2px solid #e2e8f0;\n}\n\n.stocksummary-cancel-btn:hover {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n/* Empty State */\n.stocksummary-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n}\n\n.stocksummary-no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  font-style: italic;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .stocksummary-container {\n    /* padding: 15px; */\n  }\n\n  .stocksummary-section {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  /* .stocksummary-title {\n    font-size: 2rem;\n  } */\n\n  .stocksummary-tabs {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .stocksummary-tab {\n    width: 100%;\n  }\n\n  .stocksummary-top-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .stocksummary-search-wrapper,\n  .stocksummary-select-wrapper {\n    max-width: none;\n  }\n\n  .stocksummary-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stocksummary-form-buttons {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .stocksummary-container {\n    padding: 10px;\n  }\n\n  .stocksummary-section {\n    padding: 15px;\n  }\n\n  .stocksummary-th,\n  .stocksummary-td {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n\n  /* .stocksummary-site-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  } */\n}\n\n/* Print Styles */\n@media print {\n  .stocksummary-container {\n    background: white;\n    box-shadow: none;\n  }\n\n  .stocksummary-top-controls,\n  .stocksummary-tabs,\n  .stocksummary-print-btn,\n  .stocksummary-add-btn {\n    display: none;\n  }\n\n  .stocksummary-table-container {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n\n  .stocksummary-th {\n    background: #f0f0f0 !important;\n    color: #000 !important;\n  }\n}\n\n/* **** */\n\n/* stocksummary.css */\n\n/* Base styles */\n.stocksummary-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.stocksummary-popup {\n  /* background-color: #ffffff; */\n  border-radius: 8px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  position: relative;\n  overflow-y: auto;\n  /* max-height: 90vh; */\n}\n.Used_button {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.stocksummary-form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 1.5rem; */\n}\n\n/* .stocksummary-title {\n  font-size: 1.5rem;\n  margin: 0 0 1rem 0;\n  text-align: center;\n  color: #333;\n} */\n\n.stocksummary-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.stocksummary-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.stocksummary-input,\n.stocksummary-select,\n.stocksummary-textarea {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n.stocksummary-input:focus,\n.stocksummary-select:focus,\n.stocksummary-textarea:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.stocksummary-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.stocksummary-submit-btn {\n  background-color: #007bff;\n  color: #ffffff;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.stocksummary-submit-btn:hover {\n  background-color: #0056b3;\n}\n\n.stocksummary-close-btn {\n  position: absolute;\n  top: 2rem;\n  right: 3rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #ff0000;\n  transition: color 0.3s ease;\n}\n\n.stocksummary-close-btn:hover {\n  color: #333;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .stocksummary-popup {\n    padding: 1.5rem;\n    max-width: 90%;\n  }\n\n  .stocksummary-title {\n    font-size: 1.25rem;\n  }\n\n  .stocksummary-label {\n    font-size: 0.9rem;\n  }\n\n  .stocksummary-input,\n  .stocksummary-select,\n  .stocksummary-textarea {\n    font-size: 0.9rem;\n    padding: 0.6rem;\n  }\n\n  .stocksummary-submit-btn {\n    font-size: 0.9rem;\n    padding: 0.6rem;\n  }\n\n  .stocksummary-close-btn {\n    font-size: 1.25rem;\n    top: 0.75rem;\n    right: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .stocksummary-overlay {\n    padding: 0.5rem;\n  }\n\n  .stocksummary-popup {\n    padding: 1rem;\n    max-height: 95vh;\n  }\n\n  .stocksummary-form {\n    gap: 1rem;\n  }\n\n  .stocksummary-field {\n    gap: 0.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
